import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigsLoaderService} from "./config-loader.service";
import {Item} from "../models/item.inferface";
import { Observable } from 'rxjs';
import {Form} from "../models/form";

@Injectable({providedIn: 'root'})
export class ComplaintService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
    ) {
    this.apiUrl = `${this.config.apiUrl}/Complaints/`;
  }

  getFormConfig(): Observable<Form>{
    return this.httpClient.get<Form>(`${this.apiUrl}GetComplaintConsultationForm`);
  }

  getConsultationSettings(): Observable<ConsultationDisclaimer>{
    return this.httpClient.get<ConsultationDisclaimer>(`${this.apiUrl}GetComplaintConsultationSettings`);
  }
  
  saveQuestion(form) : Observable<string>{
    return this.httpClient.post(`${this.apiUrl}SaveForm`, form, {responseType: 'text'});
  }

  validatePassWord(password): Observable<any>{
    return this.httpClient.post(`${this.apiUrl}ValidateKey`, password);
  }

  getClassificationDefault(){
    return this.httpClient.get(`${this.apiUrl}GetComplaintClassificationDefault`);
  }
}

export interface ConsultationDisclaimer{
  complaintConsultationDisclaimer: string
}